<template>
  <div class="content-top-padding padding-for-footer" v-cloak>
    <div class="container my-5">
      <div
        class="
          row
          routing
          d-flex
          justify-content-between
          align-items-center
          mb-5
        "
      >
        <div class="col main-theme d-flex flex-row align-items-center">
          <router-link :to="{ name: 'BoardMembers' }" class="">
            <img class="mr-2 route-arrow" src="@/assets/01/btn_catalog_arrow_l.svg" />
          </router-link>
          <router-link :to="{ name: 'BoardMembers' }" class="">
            {{ $t("title.bms") }}
          </router-link>
        </div>
        <div class="col main-theme d-flex justify-content-end text-right align-items-center">
          <router-link :to="{ name: 'Initiatives' }" class="">
            {{ $t("title.init") }}
          </router-link>
          <router-link :to="{ name: 'Initiatives' }" class="">
            <img class="ml-2 route-arrow" src="@/assets/01/btn_catalog_arrow_r.svg" />
          </router-link>
        </div>
      </div>
      <div class="row d-flex flex-column">
        <div class="col">
          <h3 class="main-theme text-uppercase font-weight-bold mb-5">
            {{ $t("title.supportToEcon") }}
          </h3>
        </div>
        <div class="col text-theme text-justify" v-if="$i18n.locale == 'zh'">
          2019冠狀病毒病疫情期間，入境旅遊接近完全停頓。旅遊業在疫情前提供大量就業職位。旅發局因時制宜，在
          2020/21 年度集中推動本地旅遊， 讓旅遊業在出入境的限制下，仍能貢獻香港經濟。在 2020 年 6
          月，旅發局推出全面的一站式平台「旅遊 ·
          就在香港」，透過一系列活動帶動本地氣氛、刺激消費活動，並成功為相關業界創造乘數效應，持續支持本地的經濟。
        </div>
        <div class="col text-theme text-justify" v-else>
          During the COVID-19 pandemic, inbound travel has been largely suspended due to COVID-19.
          Tourism industry in Hong Kong has been one of the major industries and supported a large
          part of the workforce before the pandemic. The Hong Kong Tourism Board has taken the
          initiative to focus on local tourism in 2020/21 with a view to continuing to contribute to
          the city’s economy when travel restrictions are in place. A series of initiatives to
          cheerlead for local ambience and boost consumptions came into place through a
          comprehensive, inclusive campaign platform “Holiday at Home” in June 2020, which has
          created a multiplying chain of consumption and provided support to Hong Kong economy.
        </div>
      </div>
    </div>

    <div class="container-fluid my-5 pb-5">
      <div class="container">
        <div class="row">
          <div class="col">
            <h3 class="main-theme mb-5" v-if="$i18n.locale == 'zh'">
              「旅遊 · 就在香港」：「賞你遊」及「賞你住」
            </h3>
            <h3 class="main-theme mb-5" v-else>
              HOLIDAY AT HOME — SPEND-TO-REDEEM PROGRAMMES
            </h3>
          </div>
        </div>
        <div class="row gif d-flex justify-content-center mb-4 pb-4 pt-3">
          <div class="col-12 col-sm-10 col-lg-6 mb-4">
            <video autoplay muted playsinline class="vid" v-if="$i18n.locale == 'zh'">
              <source src="@/assets/supportToEconomy/animation1-c.mp4" type="video/mp4" />
            </video>
            <video autoplay muted playsinline class="vid" v-else>
              <source src="@/assets/supportToEconomy/animation1-e.mp4" type="video/mp4" />
            </video>
          </div>
          <div class="col-12 col-sm-10 col-lg-6 mb-4">
            <video autoplay muted playsinline class="vid" v-if="$i18n.locale == 'zh'">
              <source src="@/assets/supportToEconomy/animation2-c.mp4" type="video/mp4" />
            </video>
            <video autoplay muted playsinline class="vid" v-else>
              <source src="@/assets/supportToEconomy/animation2.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>

    <div class="container my-5">
      <div class="row">
        <div class="col-12">
          <h3 class="main-theme mb-5" v-if="$i18n.locale == 'zh'">
            旅發局活動帶來經濟效益：帶動本地氣氛
          </h3>
          <h3 class="main-theme mb-5" v-else>
            HOLIDAY AT HOME CAMPAIGN — CHEERLEADING FOR LOCAL TOURISM
          </h3>
        </div>
        <div class="col-2 text-theme" v-if="$i18n.locale == 'zh'">入住率 (%)</div>
        <div class="col-2 text-theme" v-else>Occupancy rate (%)</div>
        <div class="col text-theme text-center" v-if="$i18n.locale == 'zh'">
          非隔離酒店
        </div>
        <div class="col text-theme text-center" v-else>Non-quarantine hotels</div>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-lg-11 col-xl-12">
          <Chart ref="chart" :testProp="trigger" />
        </div>
      </div>
    </div>

    <div class="container my-5">
      <div class="row">
        <div class="col">
          <h3 class="main-theme mb-4" v-if="$i18n.locale == 'zh'">2020 年旅遊業概況</h3>
          <h3 class="main-theme mb-4" v-else>2020 TOURISM PERFORMANCES</h3>
        </div>
      </div>

      <div class="row numberBox1 boxes frame">
        <div class="col-sm-12 col-lg-6 filled">
          <div class="content">
            <div class="title" v-if="$i18n.locale == 'zh'">訪港旅客人次：</div>
            <div class="title" v-else>Total arrivals:</div>
            <div class="stats large-stat min-height">
              <number
                ref="number1"
                :from="0"
                :to="360"
                :format="theFormat"
                :duration="duration"
                :delay="delay"
                easing="Power3.easeOut"
                animationPaused
                v-if="$i18n.locale == 'zh'"
              />
              <number
                ref="number1"
                :from="0"
                :to="3.6"
                :format="theFormat"
                :duration="duration"
                :delay="delay"
                easing="Power3.easeOut"
                animationPaused
                v-else
              />
              <span v-if="$i18n.locale == 'zh'">萬</span>
              <span v-else>million</span>
            </div>
            <div class="original-stat-up" v-if="$i18n.locale == 'zh'">5,030萬<sup>#</sup></div>
            <div class="original-stat-up" v-else>50.3 million<sup>#</sup></div>
          </div>
        </div>
        <div class="col-6 col-lg-3 filled">
          <div class="content">
            <div class="title" v-if="$i18n.locale == 'zh'">過夜旅客人次：</div>
            <div class="title" v-else>Overnight arrivals:</div>
            <div class="stats medium-stat min-height d-flex align-items-center">
              <number
                ref="number2"
                :from="0"
                :to="140"
                :format="theFormat"
                :duration="duration"
                :delay="delay"
                easing="Power3.easeOut"
                animationPaused
                v-if="$i18n.locale == 'zh'"
              />
              <number
                ref="number2"
                :from="0"
                :to="1.4"
                :format="theFormat"
                :duration="duration"
                :delay="delay"
                easing="Power3.easeOut"
                animationPaused
                v-else
              />
              <span v-if="$i18n.locale == 'zh'">萬</span>
              <span v-else>&nbsp;million</span>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3 filled">
          <div class="content">
            <div class="title" v-if="$i18n.locale == 'zh'">不過夜旅客人次：</div>
            <div class="title" v-else>Same-day arrivals:</div>
            <div class="stats medium-stat min-height d-flex align-items-center">
              <number
                ref="number3"
                :from="0"
                :to="220"
                :format="theFormat"
                :duration="duration"
                :delay="delay"
                easing="Power3.easeOut"
                animationPaused
                v-if="$i18n.locale == 'zh'"
              />
              <number
                ref="number3"
                :from="0"
                :to="2.2"
                :format="theFormat"
                :duration="duration"
                :delay="delay"
                easing="Power3.easeOut"
                animationPaused
                v-else
              />
              <span v-if="$i18n.locale == 'zh'">萬</span>
              <span v-else>&nbsp;million</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row numberBox2 boxes">
        <div class="col-md-12 col-lg-6 col-xl-3 frame">
          <div class="content light">
            <div class="title" v-if="$i18n.locale == 'zh'">
              與入境旅遊相關的總消費：<br />&nbsp;
            </div>
            <div class="title d-none d-xl-block" v-if="$i18n.locale == 'en'">
              Total tourism expenditure associated with inbound tourism (TEAIT):
            </div>
            <div class="title d-block d-xl-none" v-if="$i18n.locale == 'en'">
              Total tourism expenditure associated with inbound tourism (TEAIT):<br />&nbsp;
            </div>
            <div class="stats medium-stat" v-if="$i18n.locale == 'zh'">
              <number
                ref="number4"
                :from="0"
                :to="159"
                :format="theFormat"
                :duration="duration"
                :delay="delay"
                easing="Power3.easeOut"
                animationPaused
              />
              億港元*
            </div>
            <div class="stats medium-stat" v-else>
              HK$<number
                ref="number4"
                :from="0"
                :to="15.9"
                :format="theFormat"
                :duration="duration"
                :delay="delay"
                easing="Power3.easeOut"
                animationPaused
              />
              billion*
            </div>
            <div class="original-stat-down" v-if="$i18n.locale == 'zh'">
              2,314 億港元<sup>#</sup>
            </div>
            <div class="original-stat-down" v-else>HK$231.4 billion<sup>#</sup></div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6 col-xl-3 frame">
          <div class="content light">
            <div class="title" v-if="$i18n.locale == 'zh'">過夜旅客人均消費：<br />&nbsp;</div>
            <div class="title" v-else>Overnight visitors' per capita spending:<br />&nbsp;</div>
            <div class="stats medium-stat" v-if="$i18n.locale == 'zh'">
              <number
                ref="number5"
                :from="0"
                :to="5426"
                :format="theFormat"
                :duration="duration"
                :delay="delay"
                easing="Power3.easeOut"
                animationPaused
              />港元*
            </div>
            <div class="stats medium-stat" v-else>
              HK$<number
                ref="number5"
                :from="0"
                :to="5426"
                :format="theFormat"
                :duration="duration"
                :delay="delay"
                easing="Power3.easeOut"
                animationPaused
              />*
            </div>
            <div class="original-stat-down" v-if="$i18n.locale == 'zh'">5,612 港元<sup>#</sup></div>
            <div class="original-stat-down" v-else>HK$5,612<sup>#</sup></div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6 col-xl-3 frame">
          <div class="content light">
            <div class="title" v-if="$i18n.locale == 'zh'">過夜旅客平均留港時間：<br />&nbsp;</div>
            <div class="title" v-else>
              Average length of stay among overnight visitors:
            </div>
            <div class="stats medium-stat">
              <number
                ref="number6"
                :from="0"
                :to="10.4"
                :format="theFormat"
                :duration="duration"
                :delay="delay"
                easing="Power3.easeOut"
                animationPaused
              />
              <span v-if="$i18n.locale == 'zh'">晚</span>
              <span v-else>&nbsp;nights</span>
            </div>
            <div class="original-stat-down" v-if="$i18n.locale == 'zh'">3.2 晚<sup>#</sup></div>
            <div class="original-stat-down" v-else>3.2 nights<sup>#</sup></div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6 col-xl-3 frame">
          <div class="content light">
            <div class="title" v-if="$i18n.locale == 'zh'">
              過夜旅客整體滿意度<br />(滿分為 10 分)：
            </div>
            <div class="title" v-else>
              Overall satisfaction of overnight visitors (Max: 10 points):
            </div>
            <div class="title"></div>
            <div class="stats medium-stat">
              <number
                ref="number7"
                :from="0"
                :to="8.8"
                :format="theFormat"
                :duration="duration"
                :delay="delay"
                easing="Power3.easeOut"
                animationPaused
              />*
            </div>
            <div class="original-stat-down">8.5<sup>#</sup></div>
          </div>
        </div>
      </div>

      <div class="row mb-5">
        <div class="col">
          <div class="stat-note main-theme text-right" v-if="$i18n.locale == 'zh'">
            <sup>#</sup> 2020年1月的預測
          </div>
          <div class="stat-note main-theme text-right" v-else>
            <sup>#</sup> Original projection in January 2020
          </div>
          <div class="stat-note main-theme text-right" v-if="$i18n.locale == 'zh'">
            * 資料來源：2020年1月1日至2月4日期間離港旅客統計
          </div>
          <div class="stat-note main-theme text-right" v-else>
            * Source: Survey of departing visitors between 1 January and 4 February 2020
          </div>
        </div>
      </div>

      <div
        class="
          row
          routing
          d-flex
          justify-content-between
          align-items-center
          mb-5
        "
      >
        <div class="col main-theme d-flex flex-row align-items-center">
          <router-link :to="{ name: 'BoardMembers' }" class="">
            <img class="mr-2 route-arrow" src="@/assets/01/btn_catalog_arrow_l.svg" />
          </router-link>
          <router-link :to="{ name: 'BoardMembers' }" class="">
            {{ $t("title.bms") }}
          </router-link>
        </div>
        <div class="col main-theme d-flex justify-content-end text-right align-items-center">
          <router-link :to="{ name: 'Initiatives' }" class="">
            {{ $t("title.init") }}
          </router-link>
          <router-link :to="{ name: 'Initiatives' }" class="">
            <img class="ml-2 route-arrow" src="@/assets/01/btn_catalog_arrow_r.svg" />
          </router-link>
        </div>
      </div>
    </div>
    <BackToTopBtn />
  </div>
</template>

<script>
import Chart from "@/components/SupportToEconomy/Chart.vue";
import BackToTopBtn from "@/components/BackToTopBtn.vue";

export default {
  name: "SupportToEconomy",
  components: {
    Chart,
    BackToTopBtn,
  },
  metaInfo: {
    title: "Our Support To Economy",
    titleTemplate: "%s - HKTB Annual Report 2020/21",
  },
  data() {
    return {
      duration: 3,
      delay: 1,
      trigger: false,
    };
  },
  methods: {
    theFormat(number) {
      if (number > 100) {
        return number.toLocaleString("en-US", { maximumFractionDigits: 0 });
      } else {
        return number.toFixed(1);
      }
    },
    isScrolledIntoView(el) {
      let rect = el.getBoundingClientRect();
      let elemTop = rect.top;
      let elemBottom = rect.bottom;

      let isVisible = elemTop < window.innerHeight && elemBottom >= 0;
      return isVisible;
    },
    scroll() {
      window.onscroll = () => {
        let scrolledTo = document.querySelector(".numberBox1");
        let scrolledTo2 = document.querySelector(".numberBox2");
        let scrolledTo3 = document.querySelector(".chart");

        let bttBTN = document.querySelector("#backToTop");

        bttBTN.style.display = "none";
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
          bttBTN.style.display = "block";
        } else {
          bttBTN.style.display = "none";
        }

        if (scrolledTo2 && this.isScrolledIntoView(scrolledTo2)) {
          this.$refs.number4.play();
          this.$refs.number5.play();
          this.$refs.number6.play();
          this.$refs.number7.play();
        }
        if (scrolledTo && this.isScrolledIntoView(scrolledTo)) {
          this.$refs.number1.play();
          this.$refs.number2.play();
          this.$refs.number3.play();
        }
        if (scrolledTo3 && this.isScrolledIntoView(scrolledTo3)) {
          this.trigger = true;
          // let chart = this.$refs.chart;
          // chart.rolling();
        }
      };
    },
  },
  mounted() {
    this.scroll();
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.container-fluid {
  background-image: url(../assets/supportToEconomy/dashboard_bgimg2.jpg);
  background-size: cover;
}
.vid {
  width: inherit;
}
.frame {
  padding: 0.8rem;
}
.filled {
  background-color: #e81b29;
  color: #fff;
}
.light {
  color: #e81b29;
}
.boxes {
  .content {
    border: 1px solid #e81b29;
    padding: 0.8rem;
    .stats {
      min-height: 65px;
    }
    .large-stat {
      font-size: 4rem;
    }
    .medium-stat {
      font-size: 2.4rem;
    }
    .min-height {
      min-height: 100px;
    }
  }
}
.stat-note {
  font-size: 0.8rem;
}
.original-stat-up {
  font-size: 24px;
  color: #fff;
}
.original-stat-down {
  font-size: 20px;
  color: #aeaeae;
}
@media (max-width: 575px) {
  .numberBox1 {
    padding: 0;
    .content {
      border: 0;
    }
  }
  h3 {
    font-size: 1.3rem;
  }
}
@media (max-width: 375px) {
  .boxes {
    .content {
      .large-stat {
        font-size: 3.5rem;
      }
      .medium-stat {
        font-size: 2.1rem;
      }
    }
  }
  .original-stat-up {
    font-size: 1.2rem;
  }
  .numberBox1 {
    .content {
      padding: 0.6rem;
    }
  }
}
</style>
